<div class="container" *ngIf="isOfficeReady">
  <plan-footer
    *ngIf="(dynamicFooterEnabled$ | async) && isWellfitAdmin; else legacyFooter"
    [templateId]="effectiveTemplateId"
    [type]="effectiveType"
    [coverageLevelId]="effectiveCoverageLevelId"
    (footerRendered)="onFooterRendered($event)"
    (footerClientFallback)="onFooterClientFallback($event)">
  </plan-footer>
  <ng-template #legacyFooter>
    <app-legal-text [officeData]="officeData"></app-legal-text>
  </ng-template>
</div>
